import { useEffect, useRef } from "react";

import type { MultiDayFocus } from "../../stores/settings.store.js";
import { useLocalDayKey } from "../../lib/useLocalDayKey.js";
import { multiDayFocusAnchor, rollMultiDayFocusAnchor } from "./multi-day-focus.js";

type SetAnchor = (next: Date | ((previous: Date) => Date)) => void;

export function useMultiDayFocusRollover(
  setAnchor: SetAnchor,
  focus: MultiDayFocus,
  weekStartsOn: 0 | 1,
): void {
  const dayKey = useLocalDayKey();
  const previousDayRef = useRef(new Date());
  const configRef = useRef(`${focus}:${weekStartsOn}`);

  useEffect(() => {
    const currentDay = new Date();
    const previousDay = previousDayRef.current;
    const config = `${focus}:${weekStartsOn}`;
    if (config !== configRef.current) {
      setAnchor(multiDayFocusAnchor(currentDay, focus, weekStartsOn));
      configRef.current = config;
    } else if (currentDay.toDateString() !== previousDay.toDateString()) {
      setAnchor((anchor) => rollMultiDayFocusAnchor(anchor, previousDay, currentDay, focus, weekStartsOn));
    }
    previousDayRef.current = currentDay;
  }, [dayKey, focus, setAnchor, weekStartsOn]);
}
